import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { PageState } from 'app/store/models/page.model';
import { setBannerComponent } from 'app/store/actions/page.action';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {
  ngOnInit() {}
}
